"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnlineFirstAppointmentSuccess = void 0;
const react_1 = __importStar(require("react"));
const OnlineFirstAppointment_style_1 = require("../OnlineFirstAppointment.style");
const GlobalStyles_1 = require("../../../../../helper/GlobalStyles");
const react_native_1 = require("react-native");
const atome_1 = require("../../../../atome");
const organisms_1 = require("../../../../organisms");
const async_storage_1 = __importDefault(require("@react-native-async-storage/async-storage"));
const Breakpoints_1 = require("../../../../../helper/Breakpoints");
function OnlineFirstAppointmentSuccess({ navigation, }) {
    const [appointmentData, setAppointmentData] = (0, react_1.useState)();
    const [appointmentDoctor, setAppointmentDoctor] = (0, react_1.useState)();
    const getAppointmentInfos = async () => {
        const appointment = await async_storage_1.default.getItem('appointmentData');
        const doctor = await async_storage_1.default.getItem('appointmentDoctor');
        if (!appointment || !doctor) {
            navigation.navigate('Dashboard');
        }
        if (appointment && doctor) {
            setAppointmentData(JSON.parse(appointment));
            setAppointmentDoctor(JSON.parse(doctor));
            await async_storage_1.default.multiRemove(['appointmentData', 'appointmentDoctor']);
        }
    };
    (0, react_1.useEffect)(() => {
        getAppointmentInfos();
    }, []);
    return (react_1.default.createElement(react_native_1.SafeAreaView, null,
        react_1.default.createElement(react_native_1.ScrollView, { style: [OnlineFirstAppointment_style_1.styles.scrollview] },
            Breakpoints_1.isDesktop && react_1.default.createElement(organisms_1.UserHeader, { navigation: navigation }),
            react_1.default.createElement(react_native_1.View, { style: OnlineFirstAppointment_style_1.styles.container },
                react_1.default.createElement(react_native_1.View, { style: OnlineFirstAppointment_style_1.styles.marginTop4px },
                    react_1.default.createElement(atome_1.Icon, { icon: 'checkCircleFilled' })),
                react_1.default.createElement(react_native_1.View, { style: OnlineFirstAppointment_style_1.styles.header },
                    react_1.default.createElement(atome_1.Text, { style: [OnlineFirstAppointment_style_1.styles.headerTitle, OnlineFirstAppointment_style_1.styles.greenText] }, "Ihr Termin ist gebucht!")),
                react_1.default.createElement(react_native_1.View, { style: OnlineFirstAppointment_style_1.styles.locationsContainer },
                    react_1.default.createElement(react_native_1.View, { style: [OnlineFirstAppointment_style_1.styles.confirmationBox, OnlineFirstAppointment_style_1.styles.shadowContainer] },
                        react_1.default.createElement(react_native_1.View, { style: GlobalStyles_1.globalStyles.marginBottom25 },
                            appointmentData && (react_1.default.createElement(atome_1.Text, { style: [
                                    OnlineFirstAppointment_style_1.styles.blackText,
                                    OnlineFirstAppointment_style_1.styles.boldText,
                                    GlobalStyles_1.globalStyles.marginBottom25,
                                ] },
                                "Ihr Online Termin am",
                                ' ',
                                new Date(appointmentData.startDate).toLocaleString('de-DE', {
                                    day: '2-digit',
                                    month: 'long',
                                    year: 'numeric',
                                }),
                                ' ',
                                "wurde erfolgreich gebucht. Eine Best\u00E4tigung wurde Ihnen soeben per E-Mail \u00FCbermittelt.")),
                            react_1.default.createElement(atome_1.Text, { style: [
                                    OnlineFirstAppointment_style_1.styles.blackText,
                                    GlobalStyles_1.globalStyles.marginBottom25,
                                    GlobalStyles_1.globalStyles.textBold,
                                ] }, "Mit der E-Mail erhalten Sie ebenfalls den Aufkl\u00E4rungsbogen und den Behandlungsvertrag mit Ihrem Arzt. Diese ben\u00F6tigen wir vor Ihrem Termin unterschrieben zur\u00FCck. Alle weiteren Informationen finden Sie in der E-Mail.")),
                        react_1.default.createElement(react_native_1.View, { style: [OnlineFirstAppointment_style_1.styles.positionRelative] },
                            react_1.default.createElement(atome_1.Icon, { icon: 'calendar', size: 60, color: '#3db384' }),
                            appointmentData && (react_1.default.createElement(atome_1.Text, { style: [OnlineFirstAppointment_style_1.styles.selectedDateDay] }, new Date(appointmentData?.startDate).toLocaleString('de-DE', {
                                day: '2-digit',
                            })))),
                        react_1.default.createElement(atome_1.Text, { style: [OnlineFirstAppointment_style_1.styles.blackText, GlobalStyles_1.globalStyles.marginTop25] }, "Datum / Uhrzeit:"),
                        appointmentData && (react_1.default.createElement(atome_1.Text, { style: [
                                OnlineFirstAppointment_style_1.styles.blackText,
                                OnlineFirstAppointment_style_1.styles.boldText,
                                GlobalStyles_1.globalStyles.marginBottom25,
                            ] },
                            new Date(appointmentData?.startDate).toLocaleString('de-DE', {
                                day: '2-digit',
                                month: 'long',
                                year: 'numeric',
                            }),
                            ",",
                            ' ',
                            new Date(appointmentData?.startDate).toLocaleTimeString([], {
                                hour: '2-digit',
                                minute: '2-digit',
                                hour12: false,
                            }),
                            ' ',
                            "-",
                            ' ',
                            new Date(appointmentData.endDate).toLocaleTimeString([], {
                                hour: '2-digit',
                                minute: '2-digit',
                                hour12: false,
                            }),
                            ' ',
                            "Uhr")),
                        react_1.default.createElement(atome_1.Text, { style: [OnlineFirstAppointment_style_1.styles.blackText] }, "Arzt / \u00C4rztin:"),
                        react_1.default.createElement(atome_1.Text, { style: [OnlineFirstAppointment_style_1.styles.blackText, OnlineFirstAppointment_style_1.styles.boldText] }, appointmentData && appointmentData.doctorName))),
                react_1.default.createElement(react_native_1.View, { style: OnlineFirstAppointment_style_1.styles.successButton },
                    react_1.default.createElement(react_native_1.Pressable, { style: OnlineFirstAppointment_style_1.styles.greenButton, onPress: () => navigation.navigate('Dashboard') },
                        react_1.default.createElement(atome_1.Text, { style: [OnlineFirstAppointment_style_1.styles.greenButtonText] }, "Zum Dashboard")))))));
}
exports.OnlineFirstAppointmentSuccess = OnlineFirstAppointmentSuccess;
